import { cn } from "@/lib/utils"
import {
  PersonalInfoForm,
  type PersonalInfoFormHandle,
} from "@/components/rent/personal-info-form"
import {
  CustomerSelectForm,
  type CustomerSelectFormHandle,
} from "@/components/rent/customer-select-form"
import type { PersonalPhase } from "@/components/rent/rent-constants"
import type { Customer } from "@/types"

type PersonalStepProps = {
  isMobile: boolean
  personalPhase: PersonalPhase
  personalSideTitle: string
  customers: Customer[]
  selectedCustomerId: string
  onCustomerChange: (id: string) => void
  onPersonalTabChange: (tab: "register" | "login") => void
  personalFormRef: React.RefObject<PersonalInfoFormHandle | null>
  customerSelectRef: React.RefObject<CustomerSelectFormHandle | null>
  onLoginSubmit?: () => void
  footer?: React.ReactNode
}

export function PersonalStep({
  isMobile,
  personalPhase,
  personalSideTitle,
  customers,
  selectedCustomerId,
  onCustomerChange,
  onPersonalTabChange,
  personalFormRef,
  customerSelectRef,
  onLoginSubmit,
  footer,
}: PersonalStepProps) {
  return (
    <div className={cn("flex gap-2", isMobile ? "min-h-0 flex-col" : "h-full")}>
      <div
        className={cn(
          "relative rounded-[8px] bg-card",
          isMobile ? "shrink-0" : "min-h-[480px] grow flex-[58%]",
        )}
      >
        {personalPhase === "auth" ? (
          <PersonalInfoForm
            ref={personalFormRef}
            onTabChange={onPersonalTabChange}
            onLoginSubmit={onLoginSubmit}
          />
        ) : (
          <CustomerSelectForm
            ref={customerSelectRef}
            customers={customers}
            value={selectedCustomerId}
            onValueChange={onCustomerChange}
          />
        )}
      </div>
      {!isMobile && (
        <div className="relative h-full min-h-[480px] grow flex-[42%] rounded-[8px] bg-card p-8">
          <div className="flex h-full flex-col">
            <div className="text-[58px] font-semibold leading-[56px] text-foreground">
              {personalSideTitle}
            </div>
          </div>
          {footer}
        </div>
      )}
    </div>
  )
}
